import { usePhoneNumbers } from 'staticQueries/phone-numbers';
import { useSsr } from 'utils/hooks';
import { getCountryCode } from 'utils/localisation';

export default function LocalisedPhone({ defaultLocale = 'en', children }) {
  const isSsr = useSsr();
  const phoneNumbers = usePhoneNumbers();
  const defaultPhone = phoneNumbers.find(({ isDefault }) => isDefault).phone;

  const getPhoneByLocale = locale => {
    const normalizeCountryCodes = countries => countries?.map(country => country.toLowerCase());
    const isLocaleMatch = ({ countries }) => normalizeCountryCodes(countries)?.includes(locale);

    return phoneNumbers.find(isLocaleMatch)?.phone;
  };

  const getPreparedPhone = () => {
    switch (defaultLocale) {
      case 'az':
      case 'ae':
      case 'kz':
      case 'pl':
      case 'nl':
        return getPhoneByLocale(defaultLocale) || defaultPhone;
      case 'uk':
        return getPhoneByLocale('gb') || defaultPhone;
      case 'de':
        if (getCountryCode()?.toLowerCase() === 'nl') {
          return getPhoneByLocale('nl') || defaultPhone;
        }
        return getPhoneByLocale(defaultLocale) || defaultPhone;
      default:
        return (
          getPhoneByLocale(getCountryCode()?.toLowerCase()) ||
          getPhoneByLocale(defaultLocale) ||
          defaultPhone
        );
    }
  };

  if (isSsr) {
    return null;
  }

  return children(getPreparedPhone());
}
